import { LanDisconnectIcon } from './LanDisconnectIcon';

/**
 * author: Simran
 * id 10DCD7DC-998B-4631-B8A6-A0D8C93412A3
 * name lan-disconnect
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lan-disconnect.svg
 * tags
 */
export const LocalAreaNetworkDisconnectIcon = LanDisconnectIcon;
export default LocalAreaNetworkDisconnectIcon